'use strict';

module.exports = {
  VIDEO: {
    url: '//stampsy-eu-1.s3.amazonaws.com/uploads/11/04/2014/user/5/39f44ce7-7a7c-471c-a4f1-3295cab5e5b9.png',
    intendedScale: 2,
    size: {
      width: 1408,
      height: 824
    }
  },

  AUDIO: {
    url: '//stampsy-eu-1.s3.amazonaws.com/uploads/11/04/2014/user/5/b7d351ee-721e-4d02-a716-864299929fe8.png',
    intendedScale: 2,
    size: {
      width: 1408,
      height: 824
    }
  },

  TEXT: {
    url: '//stampsy-eu-1.s3.amazonaws.com/uploads/11/04/2014/user/5/58a74f40-f364-4f12-bbe5-65d4a70b9070.png',
    intendedScale: 2,
    size: {
      width: 1408,
      height: 334
    }
  },

  GALLERY: {
    url: '//stampsy-eu-1.s3.amazonaws.com/uploads/11/04/2014/user/5/fea75e4d-af17-4134-8fae-ed874a6ca015.png',
    intendedScale: 2,
    size: {
      width: 1408,
      height: 824
    }
  },

  POSTER: {
    url: '//stampsy-eu-1.s3.amazonaws.com/uploads/11/04/2014/user/5/170cc9fe-138c-4605-8673-539c6c7c8fc6.png',
    intendedScale: 2,
    size: {
      width: 1408,
      height: 824
    }
  }
};


/** WEBPACK FOOTER **
 ** ./constants/EditorDragImages.js
 **/